// extracted by mini-css-extract-plugin
export var pageComponentsWrapper = "PageComponents-module--page-components-wrapper--nOQbY";